module.exports = function (s) {
  s = s === undefined ? '' : s
  s = s === null ? '' : s
  s = s.toString()
  return s
}



//////////////////
// WEBPACK FOOTER
// /var/www/nitrointeractive.dev/releases/20220802215704/web/app/themes/catalyst-2018/node_modules/list.js/src/utils/to-string.js
// module id = 8
// module chunks = 0